<template>
  <div class="draft-editor">
    <span style="margin-bottom:20px;width:100%;float:left;color:#e51515">
      {{ selectedOrderLineDraft.errors ? selectedOrderLineDraft.errors.map(err => $t(err)).join('&emsp;') : '' }}
    </span>
    <div
      v-loading="loading"
      :element-loading-text="$t('orderDraft.calculating')"
      style="width:60%;float:left;background-color: rgba(233, 239, 243, 0.97);margin-right:20px;"
    >
      <div v-if="selectedOrderLineDraft.productGroup === CURTAIN_PANEL">
        <curtain
          :calculate-order-toggle="calculateOrderToggle"
          :curtain="selectedOrderLineDraft.curtain"
          :general-finishes="generalFinishes"
          :order-line-draft="selectedOrderLineDraft"
          :product-group="selectedOrderLineDraft.productGroup"
          :quarter-panels="settings && settings.quarterPanelsYN"
          :settings="getSettings('OG')"
          :grommets="grommets"
          @loading="onLoading"
        />
      </div>
      <div v-else-if="selectedOrderLineDraft.productGroup === CURTAIN_ROOM_HIGH">
        <curtain
          :calculate-order-toggle="calculateOrderToggle"
          :curtain="selectedOrderLineDraft.curtain"
          :general-finishes="generalFinishes"
          :order-line-draft="selectedOrderLineDraft"
          :product-group="selectedOrderLineDraft.productGroup"
          :quarter-panels="settings && settings.quarterPanelsYN"
          :settings="getSettings('KH')"
          :grommets="grommets"
          @loading="onLoading"
        />
      </div>
      <div v-else-if="selectedOrderLineDraft.productGroup === NET_CURTAIN_ROOM_HIGH">
        <curtain
          :calculate-order-toggle="calculateOrderToggle"
          :curtain="selectedOrderLineDraft.curtain"
          :general-finishes="generalFinishes"
          :order-line-draft="selectedOrderLineDraft"
          :product-group="selectedOrderLineDraft.productGroup"
          :quarter-panels="settings && settings.quarterPanelsYN"
          :settings="getSettings('VI')"
          :grommets="grommets"
          @loading="onLoading"
        />
      </div>
      <div v-else-if="selectedOrderLineDraft.productGroup === ROMAN_BLIND">
        <roman-blind
          :calculate-order-toggle="calculateOrderToggle"
          :fabric="selectedFabric"
          :lining="selectedLining"
          :order-line-draft="selectedOrderLineDraft"
          :roman-blind="selectedOrderLineDraft.romanBlind"
          :settings="getSettings('VG')"
        />
      </div>
      <div v-else-if="selectedOrderLineDraft.productGroup === TIE_BACK">
        <tie-back :embrace="selectedOrderLineDraft.embrace" :order-line-draft="selectedOrderLineDraft" />
      </div>
    </div>
    <div
      v-show="selectedOrderLineDraft.productGroup !== null && selectedOrderLineDraft.productGroup !== undefined"
      style="width:38%;float:left;"
    >
      <div style="background-color:rgba(233,239,243,0.97);">
        <el-header>{{ $t('common.fabric') }}</el-header>
        <el-form-item :label="$t('orderLine.fabricName')">
          <PickRec
            :key="selectedOrderLineDraft.lineNumber"
            :value="selectedOrderLineDraft.fabricProductID"
            :caption="'common.fabric'"
            value-field="id"
            :label-field="'description'"
            :input-field="'description'"
            :maxlength="64"
            :columns="[
              { field: 'code', label: 'fabric.domainProductCode' },
              { field: 'description', label: 'common.description' },
              { field: 'productTypeDescription', label: 'common.fabricType' }
            ]"
            entity="InteriorDecoratorFabric"
            :required="false"
            :use-pagination="true"
            :hide-input="false"
            :suggest="true"
            :disable-link="true"
            style="width:80%;float:left"
            @item="onFabricSelected"
          />
          <el-button
            v-if="canCreateFabrics()"
            size="mini"
            type="primary"
            icon="el-icon-circle-plus"
            style="float:left"
            @click="
              () => {
                createFabricVisible = true;
                createLiningYN = false;
              }
            "
          />
        </el-form-item>
        <el-form-item :label="$t('fabric.productType')">
          {{ selectedOrderLineDraft.fabricProductTypeDescription }}
        </el-form-item>
        <el-form-item :label="$t('interiorDecorator.fabricWidth')">
          {{ selectedOrderLineDraft.fabricWidthInCm || '' }}
        </el-form-item>
      </div>
      <div
        :hidden="selectedOrderLineDraft.productGroup === TIE_BACK"
        style="background-color:rgba(233,239,243,0.97);margin-top:10px;"
      >
        <el-header>{{ $t('common.lining') }}</el-header>
        <el-form-item :label="$t('orderLine.fabricName')">
          <PickRec
            :key="selectedOrderLineDraft.lineNumber"
            :value="selectedOrderLineDraft.liningProductID"
            :caption="'common.fabric'"
            value-field="id"
            :label-field="'description'"
            :input-field="'description'"
            :maxlength="64"
            :columns="[
              { field: 'code', label: 'fabric.domainProductCode' },
              { field: 'description', label: 'common.description' },
              { field: 'productTypeDescription', label: 'common.fabricType' }
            ]"
            entity="InteriorDecoratorFabric"
            :required="false"
            :use-pagination="true"
            :hide-input="false"
            :suggest="true"
            :disable-link="true"
            style="width:80%;float:left"
            @item="onLiningSelected"
          />
          <el-button
            v-if="canCreateFabrics()"
            size="mini"
            type="primary"
            icon="el-icon-circle-plus"
            style="float:left"
            @click="
              () => {
                createFabricVisible = true;
                createLiningYN = true;
              }
            "
          />
        </el-form-item>
        <el-form-item :label="$t('fabric.productType')">
          {{ selectedOrderLineDraft.liningFabricProductTypeDescription }}
        </el-form-item>
        <el-form-item :label="$t('interiorDecorator.fabricWidth')">
          {{ selectedOrderLineDraft.liningWidthInCm || '' }}
        </el-form-item>
      </div>
      <div style="background-color:rgba(233,239,243,0.97);margin-top:10px;">
        <el-header>{{ $t('common.remarks') }}</el-header>
        <el-input
          v-model="selectedOrderLineDraft.remarks"
          style="padding: 0px 5px 5px 5px"
          type="textarea"
          :autosize="{ minRows: 2, maxRows: 5 }"
          maxlength="255"
        />
      </div>
      <div style="background-color:rgba(233,239,243,0.97);margin-top:10px;">
        <el-header>{{ $t('orderDraft.specials') }}</el-header>
        <Select
          v-model="selectedOrderLineDraft.specials"
          :placeholder="$t('orderDraft.specials')"
          clearable
          multiple
          :options="specials"
          value-field="id"
          label-field="description"
          style="padding: 0px 5px 5px 5px;"
          width-percentage="199"
        />
      </div>
    </div>
    &nbsp;
    <el-dialog
      :title="$t('route.createFabric')"
      :visible.sync="createFabricVisible"
      :close-on-click-modal="false"
      :append-to-body="true"
      :width="'600px'"
    >
      <create-fabric @closeDialogue="fabric => fabricCreated(fabric)" />
      &nbsp;
    </el-dialog>
  </div>
</template>

<script>
import PickRec from '@/components/DSE/PickRec/src/PickRec';
import Select from '@/components/DSE/Select';
import CreateFabric from './CreateFabric';
import Curtain from '@/pages/orders/CreateMultiple/Components/ProductGroups/Curtain';
import RomanBlind from '@/pages/orders/CreateMultiple/Components/ProductGroups/RomanBlind';
import TieBack from '@/pages/orders/CreateMultiple/Components/ProductGroups/TieBack';
import { InteriorDecoratorProductGroup } from './constants';

export default {
  name: 'CompleteOrderPickList',
  components: {
    Select,
    PickRec,
    CreateFabric,
    Curtain,
    RomanBlind,
    TieBack
  },
  props: {
    finishesAvailable: {
      type: Array,
      default: () => []
    },
    generalFinishes: {
      type: Array,
      default: () => []
    },
    grommets: {
      type: Array,
      default: () => []
    },
    selectedOrderLineDraft: {
      type: Object,
      default: null
    },
    settings: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      calculateOrderToggle: false,
      createFabricVisible: false,
      createLiningYN: false,
      loading: false,
      selectedFabric: undefined,
      selectedLining: undefined
    };
  },
  computed: {
    fabrics() {
      return this.$store.getters['interiorDecoratorFabric/loadedItems'];
    },
    specials() {
      return this.$store.getters['special/loadedItems'];
    }
  },
  created() {
    this.CURTAIN_PANEL = InteriorDecoratorProductGroup.CurtainPanel;
    this.CURTAIN_ROOM_HIGH = InteriorDecoratorProductGroup.CurtainRoomHigh;
    this.NET_CURTAIN_ROOM_HIGH = InteriorDecoratorProductGroup.NetCurtainRoomHigh;
    this.ROMAN_BLIND = InteriorDecoratorProductGroup.RomanBlind;
    this.TIE_BACK = InteriorDecoratorProductGroup.TieBack;
  },
  methods: {
    canCreateFabrics() {
      return this.settings && this.settings.createFabricsYN;
    },
    getSettings(productGroupCode) {
      return this.settings.productGroups.find(elem => elem.code === productGroupCode);
    },
    getProductGroupCode() {
      switch (this.selectedOrderLineDraft.productGroup) {
        case InteriorDecoratorProductGroup.CurtainPanel:
          return 'OG';
        case InteriorDecoratorProductGroup.CurtainRoomHigh:
          return 'KH';
        case InteriorDecoratorProductGroup.NetCurtainRoomHigh:
          return 'VI';
        case InteriorDecoratorProductGroup.RomanBlind:
          return 'VG';
        default:
          return '';
      }
    },
    fabricCreated(fabric) {
      this.createFabricVisible = false;
      if (this.createLiningYN) {
        this.onLiningSelected(fabric);
      } else {
        this.onFabricSelected(fabric);
      }
    },
    onFabricSelected(newValue) {
      const fabricProductID = (newValue && newValue.id) || null;
      const orderLineDraft = this.selectedOrderLineDraft;
      if (fabricProductID !== orderLineDraft.fabricProductID) {
        if (fabricProductID === null) {
          orderLineDraft.fabricDescription = '';
          orderLineDraft.fabricProductTypeDescription = '';
          orderLineDraft.fabricType = null;
          orderLineDraft.fabricWidthInCm = 0;
          orderLineDraft.fabricIsPatterned = false;
          orderLineDraft.fabricPatternHeightInMm = 0;
          orderLineDraft.fabricProductID = fabricProductID;
        } else {
          orderLineDraft.fabricDescription = newValue.description;
          orderLineDraft.fabricProductTypeDescription = newValue.productTypeDescription;
          orderLineDraft.fabricType = newValue.type;
          orderLineDraft.fabricWidthInCm = newValue.widthInCm;
          orderLineDraft.fabricIsPatterned = newValue.isPatterned;
          orderLineDraft.fabricPatternHeightInMm = newValue.patternHeightInMm;
          orderLineDraft.fabricProductID = fabricProductID;
          this.calculateOrderToggle = !this.calculateOrderToggle; // Call after setting the above properties (not before)
        }
      }
    },
    onLoading(loading) {
      this.loading = loading;
    },
    onLiningSelected(newValue) {
      const liningProductID = (newValue && newValue.id) || null;
      const orderLineDraft = this.selectedOrderLineDraft;
      if (liningProductID !== orderLineDraft.liningProductID) {
        if (liningProductID === null) {
          orderLineDraft.liningDescription = '';
          orderLineDraft.liningFabricProductTypeDescription = '';
          orderLineDraft.liningFabricType = null;
          orderLineDraft.liningWidthInCm = 0;
          orderLineDraft.liningProductID = null;
          orderLineDraft.liningBottomFinishID = null;
          orderLineDraft.liningBottomFinishMeasurementInMm = null;
          if (orderLineDraft.curtain) {
            orderLineDraft.curtain.liningPanelsLeft = null;
            orderLineDraft.curtain.liningPanelsRight = null;
            orderLineDraft.curtain.liningCutSizeLeftInCm = null;
            orderLineDraft.curtain.liningCutSizeRightInCm = null;
          }
        } else {
          orderLineDraft.liningDescription = newValue.description;
          orderLineDraft.liningFabricProductTypeDescription = newValue.productTypeDescription;
          orderLineDraft.liningFabricType = newValue.type;
          orderLineDraft.liningWidthInCm = newValue.widthInCm;
          orderLineDraft.liningProductID = liningProductID;
          const productGroupSettings = this.getSettings(this.getProductGroupCode());
          orderLineDraft.liningBottomFinishID = productGroupSettings && productGroupSettings.liningBottomFinishID;
          orderLineDraft.liningBottomFinishMeasurementInMm =
            productGroupSettings && productGroupSettings.liningBottomFinishMeasurementInMm;
          this.calculateOrderToggle = !this.calculateOrderToggle; // Call after setting the above properties (not before)
        }
      }
    }
  }
};
</script>
<style lang="scss">
.draft-editor {
  .el-form-item {
    margin-bottom: 5px;
    padding-right: 10px;
    font-size: 2px;
  }

  .el-header {
    height: 20px !important;
    background-color: #aeafb1;
    color: white;
    padding-left: 5px;
    margin-bottom: 10px;
  }

  .el-form-item--medium .el-form-item__content,
  .el-form-item--medium .el-form-item__label {
    line-height: 30px;
  }

  .material-input__component .material-input {
    padding: 0px 0px 0px 0px !important;
  }

  .el-form-item--medium .el-form-item__content,
  .el-form-item--medium .el-form-item__label {
    line-height: 25px;
  }
  .el-form-item__label {
    font-weight: bold;
  }
}
</style>
